import { render, staticRenderFns } from "./RenderPortal.vue?vue&type=template&id=b847e126&"
import script from "./RenderPortal.vue?vue&type=script&lang=js&"
export * from "./RenderPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports